import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, BadgeCheck, CheckCircle } from 'lucide-react';
const HeaderGlpAdv4 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17620" data-mp="1q6svpl8hf0ou">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17621" data-mp="203ffs7szhnpt"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17622" data-mp="12f59hgm60dsw">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17623" data-mp="12d2eei65nuhb">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17624" data-mp="17f03vu55flip">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17625" data-mp="1cbi3ygpjavop">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17626" data-mp="jodx066vs7aa">
          <div className="text-left" data-id="element-17627" data-mp="1iw35561g7vaa">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17628" data-mp="1ivkzxjwt66q8">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17629" data-mp="103ik2arzquh1">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17630" data-mp="q8grt62f5ca8">
        <div className="max-w-4xl mx-auto" data-id="element-17631" data-mp="m63qctupg0j9">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17632" data-mp="m7es6o4lay7q">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-6" data-id="element-17633" data-mp="2gjleoj2xp1fc">
            Patient Story: "I Almost Lost My Marriage Along With The Weight" —
            Why So Many GLP-1 Users Feel Numb, Exhausted, And Empty And How To
            Stay On The Medication Without The Mental Cost
          </h1>

          {/* Author Byline */}
          <div className="flex items-center gap-4 mb-6 pb-5 border-b border-gray-200" data-id="element-17634" data-mp="8y350hjvy0sg">
            <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-17635" data-mp="8vqq6d9fc6jm">
              <img src="https://cdn.magicpatterns.com/uploads/dZsfYoUn5AK95fR4SRF9oa/YCyEt6vcI9ES0sqc36Qz6.png" alt="Patient" className="w-full h-full object-cover" data-id="element-17636" data-mp="wlkzwlyg5ezn" />
            </div>
            <div className="flex-1" data-id="element-17637" data-mp="nmpwfhmsej01">
              <div className="flex items-center gap-2 mb-2" data-id="element-17638" data-mp="slu423u2c8o9">
                <span className="text-base font-medium text-gray-900" data-id="element-17639" data-mp="sk9aagfkotrg">
                  Written By Martha R.
                </span>
                <BadgeCheck className="h-5 w-5 text-blue-600" data-id="element-17640" data-mp="3dcbazhp5na2h" />
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17641" data-mp="3d9yn6nwpu5hi">
                Verified GLP-1 User • 11 Months on Treatment
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-17642" data-mp="30uh3bukyj1rm">
                <div className="flex items-center gap-1" data-id="element-17643" data-mp="3et8f3acckbcl">
                  <ClockIcon className="h-4 w-4" data-id="element-17644" data-mp="3esp6wlci11br" />
                  <span data-id="element-17645" data-mp="39tvu6v51decn">14 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-17646" data-mp="39sb0t8ugk1gd">
                  <EyeIcon className="h-4 w-4" data-id="element-17647" data-mp="2m5ulnm7uxxx8" />
                  <span data-id="element-17648" data-mp="2m2gp4ulvkixp">31,542 views</span>
                </div>
              </div>
            </div>
          </div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-17649" data-mp="2vucmu4k1u71e">
            The Breakthrough Discovery From Uppsala University Research That Is
            Allowing Over 36,700 People To Continue Losing Weight With NO
            Depression, Anxiety, Numbness, Disconnected Feeling, Loss Of
            Motivation, Insomnia, Nightmares or Sense Of Dread
          </p>

          <div className="border-t border-gray-200 pt-3 mb-6 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17650" data-mp="11omuvdw1ryjw">
            <div className="mb-1 flex items-center" data-id="element-17651" data-mp="16npzwyc124rv">
              <span className="font-medium mr-2" data-id="element-17652" data-mp="1aojl3jy355h2">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17653" data-mp="1fga228rj2rhg">
              <span className="font-medium mr-2" data-id="element-17654" data-mp="1fh2yafsv1ylc">Published:</span>
              January 2026
            </div>
          </div>

          <div className="bg-gray-50 border-l-4 border-blue-500 p-4 mb-3" data-id="element-17655" data-mp="1pcwkys0an8gu">
            <p className="text-sm text-gray-700 leading-relaxed italic" data-id="element-17656" data-mp="1ucizd4ruyur8">
              <strong data-id="element-17657" data-mp="1udahpdwg2vzk">Editor's Note:</strong> This is Martha's story. Martha R.
              is one of the estimated 16 million Americans currently on GLP-1
              weight loss medication. She's 52, a mother of two, married for 26
              years. Like millions of Americans, she started GLP-1 medication
              hoping to finally win the battle with her weight. She lost 38
              pounds in five months. She also almost lost something else. What
              follows is her account, in her own words.
            </p>
          </div>

          {/* Martha's Image */}
          <div className="mb-6" data-id="element-17658" data-mp="3iwole6axn68t"></div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpAdv4;